import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
export var OptionType;
(function (OptionType) {
    OptionType["user"] = "user";
    OptionType["group"] = "group";
})(OptionType = OptionType || (OptionType = {}));
export const emptyAutocompletePresets = {
    userLookup: {
        type: {
            single: {
                getStartAdornment: () => _jsx(_Fragment, {}),
            },
            multiple: {
                renderTags: () => _jsx(_Fragment, {}),
            },
        },
        getGroupBy: () => () => "",
        renderOption: () => _jsx(_Fragment, {}),
    },
};
//# sourceMappingURL=autocomplete.js.map